import {persistUserToSession, readUserFromSession} from "auth/session";
import type {AuthenticatedUser} from "auth/types";
import {
  createContext,
  type FC,
  type PropsWithChildren,
  useCallback,
  useState,
} from "react";

type AuthContextValue = {
  user: AuthenticatedUser | null;
  setUser: (user: AuthenticatedUser | null) => void;
  clearUser: () => void;
};

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);

export const AuthProvider: FC<PropsWithChildren> = ({children}) => {
  const [user, setUserState] = useState<AuthenticatedUser | null>(
    readUserFromSession(),
  );

  const setUser = useCallback((user: AuthenticatedUser | null) => {
    setUserState(user);
    persistUserToSession(user);
  }, []);

  const clearUser = useCallback(() => {
    setUserState(null);
    persistUserToSession(null);
  }, []);

  return (
    <AuthContext.Provider value={{user, setUser, clearUser}}>
      {children}
    </AuthContext.Provider>
  );
};
